// Full-document render of the sealy MattressFilterListPage (PLP):
// PageSkeleton (the React document shell) wrapping the page body (hero and
// blocks) and the trailing store-locator panel.
import React from "react";

import { templates } from "@reactivated";

import { StoreLocator } from "../blocks/StoreLocator";
import { MattressFilterListPageBody } from "../components/MattressFilterListPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed
// with mutable reactivated props (see PageSkeleton). The body template accepts
// Immutable props, to which these are assignable.
export const Template = (
    props: templates.MattressFilterListPageTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <MattressFilterListPageBody page={props.page} hero={props.hero} />
        {/* The value-less store-locator panel; the component ignores its
            block value (the legacy include rendered it with value=None). */}
        <StoreLocator value={null} />
    </PageSkeleton>
);
